'use client'

import DataWithLabel from '@lyra/core/components/DataWithLabel'
import formatUSD from '@lyra/core/utils/formatUSD'
import useYieldAllStats from '@lyra/web/hooks/useYieldAllStats'
import useYieldPositions from '@lyra/web/hooks/useYieldPositions'
import React, { useMemo } from 'react'

export default function YieldSummaryItems() {
  const { data: allStats, isLoading: isStatsLoading } = useYieldAllStats()
  const { data: positions, isLoading: isPositionsLoading } = useYieldPositions()

  const totalPosition = useMemo(
    () => (positions ? Object.values(positions).reduce((sum, p) => sum + p.value, 0) : 0),
    [positions]
  )
  const tvl = useMemo(
    () => (allStats ? Object.values(allStats).reduce((sum, p) => sum + p.tvl, 0) : 0),
    [allStats]
  )

  return (
    <>
      <DataWithLabel
        label="Deposited"
        value={isStatsLoading ? '...' : formatUSD(tvl, { dps: 0 })}
      />
      {totalPosition > 0 ? (
        <DataWithLabel
          label="My Positions"
          value={isPositionsLoading ? '...' : formatUSD(totalPosition)}
        />
      ) : null}
    </>
  )
}
